const en = {
  quiz_title: 'Welcome to #play4sdgs!',
  quiz_sdg_info_label: 'Learn more about SDGs',
  quiz_main_button: 'Start game',
  quiz_info_title: 'Game rules',
  quiz_info_subheader_1: 'Learn how to play:',
  quiz_info_content_1: 'The purpose of this game is to learn more about SDGs by answering the questions during the quizzes.\n\n You can play as many times as you want, choose one of the quizes and test your knowledge. If you find the correct answers you will win some gifts!',
  quiz_info_subheader_2: 'How to win?',
  quiz_info_content_2: 'To win you should pass the quiz with 90% of correct answers within the time limit. For any question you have 30 sec to answer.',
  quiz_info_subheader_3: 'What will you win?',
  quiz_info_content_3: 'In the first game/quiz you win 500MB, this bonus can be profited only once per day. \n In the second game you win 1GB, this bonus can be profited only once per week.\n in the third game you win gifts from United Narions, this gifts can be profited only once per month.',
  quiz_info_subheader_4: 'Who can play?',
  quiz_info_content_4: 'Everyone is eligible to play.',
  quiz_info_subheader_5: ' What are SDGs and where can I learn more about them?',
  quiz_info_content_5: 'Learn more by pressing',
  quiz_info_content_6: ' here.',
  quiz_level_selection_title: 'Let’s play!',
  quiz_level_selection_subtitle: 'Choose the quiz you wish to play...',
  quiz_first_level_description: 'Play and win every day, bonus can be profited only ',
  quiz_first_level_description_bold: 'once per day',
  quiz_second_level_description_bold: 'once per week',
  quiz_third_level_description_bold: 'once per month',
  quiz_game_number_slide: 'Quiz %1$s',
  quiz_game_question_number: 'Question %1$s/%2$s',
  quiz_game_collected_points: 'Points collected: ',
  quiz_game_timer: 'Time remaining 0:%1$s',
  quiz_game_confirm_button: 'Confirm',
  quiz_game_continue_button: 'Continue',
  quiz_game_play_again_button: 'Play again',
  quiz_game_correct_question: 'Correct answer!',
  quiz_game_wrong_question: 'Incorrect answer!',
  quiz_game_oot_question: 'Time is up!',
  quiz_game_finished: 'Quiz is over!',
  quiz_game_error: 'Something went wrong!',
}

export default en
